import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts"
import { Button } from "antd"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
export const GridVisualization = ({ id, sensor, navigate, title, data, domain, onSensorConfig }) =>
{
    const { t } = useTranslation()

    return (
        <div style={{ width: "100%", height: "300px", margin: "auto", paddingBottom: "20px" }}>
            <div style={{ margin: "0 auto" }}>
                <Button style={{ display: "inline-block", minWidth: "300px" }} onClick={() => navigate("/sensorlog/" + id.replaceAll("/", "!") + "/" + sensor)}>{t('page.card-details.gridvisual.seehistory')}</Button>
                <Button style={{ display: "inline-block", minWidth: "300px" }} onClick={() => onSensorConfig(sensor)}>{t('page.card-details.gridvisual.monitor')}</Button>
            </div>
            {data && data.length > 0 ? (
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={data} margin={{ top: 35, right: 5, bottom: 5, left: -35, width: "100%", height: "100%" }}>
                        <defs>
                            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#a3d1ef" stopOpacity={0.8} />
                                <stop offset="95%" stopColor="#a3d1ef" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke="#dedede" />
                        <XAxis dataKey="count" stroke="#333" />
                        <YAxis stroke="#333" domain={domain} />
                        <Tooltip wrapperStyle={{ borderColor: "white", boxShadow: "2px 2px 3px rgba(0,0,0,0.3)" }} />

                        <Area type="monotone" dataKey="value" stroke="#8884d8" fillOpacity={1} fill="url(#colorValue)" />
                    </AreaChart>
                </ResponsiveContainer>
            ) : (
                <p style={{ textAlign: "center", color: "#333" }}>Empty</p>
            )}
        </div>
    )

}

export default GridVisualization
